import {AbstractModel} from '../abstract-model';

export class TranslationDomainLocale extends AbstractModel {
  locale: string | null = null;
  previewUrl: string | null = null;
  reviewed: boolean = false;
}
